import StudentSignInBlock from './StudentSignInBlock';
import { StudentSignInBlockProps, StudentSignInBlockValueProps } from './types';

export type { StudentSignInBlockProps, StudentSignInBlockValueProps };
export default StudentSignInBlock;
